import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { AzzurroTable, CopyToClipboardModule, SimpleButtonComponent, SpinnerModule, TitleContentComponent } from 'ngx-zcs-components';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';

import { BlockTitleComponent } from '../../components/block-title/block-title.component';
import { PlantCardOverviewModule } from '../../plant-card-overview/plant-card-overview.module';
import { BaseSystemsPortingComponent } from './base-systems-porting.component';
import { SystemsPortingReportDialogComponent } from './report-dialog/porting-report-dialog';
import { SearchComponent } from '../../components/search/search.component';
import { ScrollWatcherModule } from '../../directives';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    BaseSystemsPortingComponent,
    SystemsPortingReportDialogComponent,
  ],
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    CopyToClipboardModule,
    IonicModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatPaginatorModule,
    MatTableModule,
    PlantCardOverviewModule,
    ReactiveFormsModule,
    ScrollWatcherModule,
    SearchComponent,
    SimpleButtonComponent,
    SpinnerModule,
    TitleContentComponent,
  ],
  exports: [
    BaseSystemsPortingComponent,
  ],
})
export class BaseSystemsPortingModule { }
